import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { useTheme } from '@shared/lib';
const GiftIcon: FC = () => {
  const theme = useTheme();
  return <Wrapper>
      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2_3845)">
          <path d="M7.06934 2.55313L8.36074 4.75H5.64063C4.82051 4.75 4.15625 4.08574 4.15625 3.26563C4.15625 2.44551 4.82051 1.78125 5.64063 1.78125H5.72227C6.2752 1.78125 6.79102 2.07441 7.06934 2.55313ZM2.375 3.26563C2.375 3.8 2.50488 4.30469 2.73125 4.75H1.1875C0.530664 4.75 0 5.28066 0 5.9375V8.3125C0 8.96934 0.530664 9.5 1.1875 9.5H17.8125C18.4693 9.5 19 8.96934 19 8.3125V5.9375C19 5.28066 18.4693 4.75 17.8125 4.75H16.2688C16.4951 4.30469 16.625 3.8 16.625 3.26563C16.625 1.46211 15.1629 0 13.3594 0H13.2777C12.0939 0 10.9955 0.627149 10.3943 1.64766L9.5 3.17285L8.60566 1.65137C8.00449 0.627149 6.90606 0 5.72227 0H5.64063C3.83711 0 2.375 1.46211 2.375 3.26563ZM14.8438 3.26563C14.8438 4.08574 14.1795 4.75 13.3594 4.75H10.6393L11.9307 2.55313C12.2127 2.07441 12.7248 1.78125 13.2777 1.78125H13.3594C14.1795 1.78125 14.8438 2.44551 14.8438 3.26563ZM1.1875 10.6875V17.2188C1.1875 18.2022 1.98535 19 2.96875 19H8.3125V10.6875H1.1875ZM10.6875 19H16.0313C17.0147 19 17.8125 18.2022 17.8125 17.2188V10.6875H10.6875V19Z" fill={theme.colors.icon.primary} />
        </g>
        <defs>
          <clipPath id="clip0_2_3845">
            <rect width="19" height="19" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Wrapper>;
};
export default GiftIcon;
export const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w19ciihk",
  propsAsIs: false
});

require("./GiftIcon.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./GiftIcon.tsx");